import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ReactNode } from "react";

interface ParallaxSectionProps {
  children: ReactNode;
  className?: string;
  speed?: number;
  bgImage?: string;
  overlay?: boolean;
}

const ParallaxSection = ({ children, className = "", speed = 0.3, bgImage, overlay = true }: ParallaxSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [speed * -100, speed * 100]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      {bgImage && (
        <>
          <motion.div
            className="absolute inset-0 -inset-y-20"
            style={{ y }}
          >
            <img
              src={bgImage}
              alt=""
              className="w-full h-[120%] object-cover"
              loading="lazy"
            />
          </motion.div>
          {overlay && (
            <div className="absolute inset-0 bg-background/85" />
          )}
        </>
      )}
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default ParallaxSection;
